/* naborFaze — JEDEN zdroj pravdy o fázích náboru.
 *
 * PROČ: fáze se zobrazují na dvou místech (kanban v /nabor a náborová složka
 * kontaktu). Kdyby si každé místo drželo vlastní seznam, dřív nebo později by se
 * rozešly a poradce by u jednoho člověka viděl dvě různé fáze.
 *
 * Tady jsou jen ID, názvy a barva. Gradienty a nápovědy sloupců zůstávají
 * v kanbanu — jsou to čistě vizuální věci jedné obrazovky.
 */

/** Fáze v kanbanu, v pořadí, jak jimi kandidát prochází. */
export const NABOR_FAZE = [
  { id: "tip", cs: "Tip / identifikace", sk: "Tip / identifikácia", color: "#6D48B8" },
  { id: "osloveni", cs: "Oslovení", sk: "Oslovenie", color: "#A4436B" },
  { id: "kava", cs: "Káva / 1. schůzka", sk: "Káva / 1. stretnutie", color: "#C74E22" },
  { id: "prezentace", cs: "Prezentace", sk: "Prezentácia", color: "#D69412" },
  { id: "nabidka", cs: "Nabídka", sk: "Ponuka", color: "#7FA62B" },
  { id: "nabeh", cs: "Náběh", sk: "Nábeh", color: "#0FBF62" },
];

/** Koncové stavy — v kanbanu nemají sloupec, ale kontakt v nich může být. */
export const NABOR_FAZE_KONEC = {
  aktivni: { cs: "Nabrán", sk: "Nabraný", color: "#0AA653" },
  ztraceny: { cs: "Prohraný", sk: "Stratený", color: "var(--faint)" },
};

/** Čitelný název fáze. Neznámá/prázdná fáze = první fáze (tak to bere i kanban). */
export function naborStageLabel(id, L = "cs") {
  const lang = L === "sk" ? "sk" : "cs";
  const f = NABOR_FAZE.find((x) => x.id === id);
  if (f) return f[lang];
  const k = NABOR_FAZE_KONEC[id];
  if (k) return k[lang];
  return NABOR_FAZE[0][lang];
}

/** Barva fáze — pro chip/proužek. */
export function naborStageColor(id) {
  const f = NABOR_FAZE.find((x) => x.id === id);
  if (f) return f.color;
  const k = NABOR_FAZE_KONEC[id];
  return k ? k.color : NABOR_FAZE[0].color;
}

/** Pořadí fáze (0-based) v kanbanu; koncové stavy vrací -1. */
export function naborStageIndex(id) {
  return NABOR_FAZE.findIndex((x) => x.id === id);
}
